import React from "react";
import moment from "moment";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { StyleSheet, css } from "aphrodite";
import DatePickerField from "../../GenericComponents/DatePickerField";
import GlobalSlider from "../../GenericComponents/GlobalSlider";
import styles from "../style";

class NightTimeSettingsCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { nightTimeSettings, defaultSettings, setTime, handleSliderValues } = this.props;
    return (
      Object.keys(nightTimeSettings).length !== 0 && (
        <div>
          <label
            className={css(styles.valueLabels)}
          >
            select time <br />
            <span className={css(styles.subLabels)}>
              (Night time start and end times have been adjusted to reflect the
              daytime settings)
            </span><br />
            Default : (
            {moment(
              defaultSettings.NIGHT_TIME_START.defaultValue,
              "hh:mm:ss"
            ).format("h:mm A")}{" "}
            - {moment(
              defaultSettings.NIGHT_TIME_END.defaultValue,
              "hh:mm:ss"
            ).format("h:mm A")})
          </label>
          <Row style={{ alignItems: "center", marginBottom: "1em" }}>
            <Col xs={12} sm={6} md={2}>
              <DatePickerField
                name={"nightTimeStart"}
                minTime={moment(
                  nightTimeSettings.dayTimeEnd,
                  "hh:mm:ss"
                ).toDate()}
                maxTime={moment("23:55:00", "hh:mm:ss").toDate()}
                value={moment(
                  nightTimeSettings.nightTimeStart,
                  "hh:mm:ss"
                ).toDate()}
                action={setTime}
                showTimeSelect={true}
                showTimeSelectOnly={true}
                timeIntervals={5}
                timeCaption="Time"
                dateFormat="h:mm aa"
                className={"form-control"}
              />
            </Col>
            <Col xs={12} sm={6} md={1} style={{ textAlign: "center", paddingTop: "1%" }}>
              <label className={css(styles.valueLabels)}>to</label>
            </Col>
            <Col xs={12} sm={6} md={2}>
              <DatePickerField
                name={"nightTimeEnd"}
                minTime={moment("00:00:00", "hh:mm:ss").toDate()}
                maxTime={moment(
                  nightTimeSettings.nightTimeEnd,
                  "hh:mm:ss"
                ).toDate()}
                value={moment(
                  nightTimeSettings.nightTimeEnd,
                  "hh:mm:ss"
                ).toDate()}
                action={setTime}
                showTimeSelect={true}
                showTimeSelectOnly={true}
                timeIntervals={5}
                timeCaption="Time"
                dateFormat="h:mm aa"
                className={"form-control"}
              />
            </Col>
          </Row>
          <label
            className={css(styles.valueLabels)}
          >
            degree motion sensitivity ({defaultSettings.NIGHT_SENSITIVITY.minValue} -{" "}
            {defaultSettings.NIGHT_SENSITIVITY.maxValue})<br />
            Default : {defaultSettings.NIGHT_SENSITIVITY.defaultValue}
          </label>
          <GlobalSlider
            name={"nightTimeSensitivity"}
            min={parseInt(defaultSettings.NIGHT_SENSITIVITY.minValue)}
            max={parseInt(defaultSettings.NIGHT_SENSITIVITY.maxValue)}
            value={nightTimeSettings.nightTimeSensitivity}
            //onChangeStart={this.handleChangeStart}
            action={handleSliderValues}
            //onChangeComplete={this.handleChangeComplete}
          />
          <label
            className={css(styles.valueLabels)}
          >
            motion duration to trigger an event ({defaultSettings.NIGHT_DURATION.minValue} -{" "}
            {defaultSettings.NIGHT_DURATION.maxValue}{" "}
            {defaultSettings.NIGHT_DURATION.unit})<br />
            Default : {defaultSettings.NIGHT_DURATION.defaultValue}
          </label>
          <GlobalSlider
            name={"nightTimeDuration"}
            min={parseInt(defaultSettings.NIGHT_DURATION.minValue)}
            max={parseInt(defaultSettings.NIGHT_DURATION.maxValue)}
            value={nightTimeSettings.nightTimeDuration}
            //onChangeStart={this.handleChangeStart}
            action={handleSliderValues}
            //onChangeComplete={this.handleChangeComplete}
          />
        </div>
      )
    );
  }
}

export default NightTimeSettingsCard;

const style = StyleSheet.create({
  title: {
    fontSize: "18px",
    color: "white",
  },
  subTitle: {
    fontSize: "12px",
    color: "white",
  },
  headerStyle: {
    background: "#0d6cbf",
    margin: "-1px",
  },
  footerStyles: {
    display: "block !important",
    textAlign: "center",
  },
});
